import { type Messages } from ".";

export const messagesIT: Messages = {
  HOME: {
    TITLE: "Pannello",
    ROUTE: "/dashboard",
    PAGE: "Benvenuto in DASF",
    INTRO:
      "Un framework potente per la valutazione della gestione delle catastrofi",
    SECTION1_TITLE: "Funzionalità",
    SECTION1:
      "Questa applicazione supporta la valutazione delle capacità nella gestione delle catastrofi.",
    SECTION2_TITLE: "Tecnologia",
    SECTION2: "Costruito con TypeScript e tecnologie web moderne.",
    SECTION3_TITLE: "Utilizzo",
    SECTION3: "Navigare tra le sezioni usando la barra di navigazione.",
  },
  ABOUT: {
    TITLE: "Informazioni",
    ROUTE: "/about",
    PAGE: "Informazioni su DASF",
    INTRO: "Scopri di più sul DIREKTION Assessment & Screening Framework",
    SECTION1_TITLE: "Cos'è DASF",
    SECTION1:
      "Il DIREKTION Assessment & Screening Framework aiuta le organizzazioni nella gestione delle catastrofi.",
    SECTION2_TITLE: "Caratteristiche principali",
    SECTION2:
      "Valutazione delle capacità, identificazione delle lacune, valutazione delle soluzioni e roadmap.",
    SECTION3_TITLE: "Obiettivi di sviluppo",
    SECTION3:
      "Fornire un framework chiaro e manutenibile per la gestione delle catastrofi.",
  },
  SETTINGS: {
    TITLE: "Impostazioni",
    ROUTE: "/settings",
    PAGE: "Impostazioni applicazione",
    INTRO: "Configura le preferenze dell'applicazione",
    SECTION1_TITLE: "Preferenze lingua",
    SECTION1: "Cambia tra le lingue disponibili.",
    SECTION2_TITLE: "Impostazioni aspetto",
    SECTION2: "Personalizza l'aspetto visivo dell'applicazione.",
    SECTION3_TITLE: "Preferenze",
    SECTION3: "Gestisci il comportamento dell'applicazione.",
  },
  LANDING: { TITLE: "Introduzione", ROUTE: "/" },
  HAZARDS: { TITLE: "Rischi", ROUTE: "/hazards" },
  SOLUTIONS: { TITLE: "Soluzioni", ROUTE: "/solutions" },
  ROADMAP: { TITLE: "Piano d'azione", ROUTE: "/roadmap" },
  USER: "Utente",
  EDITOR: "Editor",
  ADMIN: "Amministratore",
  CANCEL: "Annulla",
  DELETE: "Elimina",
  YES: "Sì",
  NO: "No",
  OK: "OK",
  NAME: "Nome",
  DESCRIPTION: "Descrizione",
  DELETE_ITEM: {
    TITLE: "Elimina {item}",
    DESCRIPTION:
      "Sei sicuro di voler eliminare questo {item}? Non è possibile tornare indietro.",
  },
  SAVE_BUTTON: {
    LABEL: "Salva",
    TOOLTIP: "Salva le modifiche non salvate",
  },
  SEARCH: "Cerca...",
  SEARCH_TOOLTIP: "Digita / per cercare",
  LANGUAGE: "Lingua",
  CLEAR: "Cancella modello",
  UPLOAD: "Carica modello come JSON",
  DOWNLOAD: "Scarica modello come JSON",
  PERMALINK: "Crea collegamento permanente",
  ROLE: "Ruolo",
  LINK: "Collegamento",
  MODEL: "Modello",
  TITLE: "Titolo",
  AUTHORS: "Autori",
  TYPE: "Tipo",
  HITS: {
    n: "{n} Risultati",
  },
  NO_RESULTS: "Nessun risultato trovato",
  CLEAR_SEARCH: "Cancella ricerca",
  PAGE_NOT_FOUND: "Pagina non trovata",

  about_route: "/about",
  about: "Informazioni",
  acronym: "Acronimo",
  add_term: "Aggiungi un nuovo termine",
  addr_how: "Come viene affrontato?",
  addressed: "Affrontato",
  ass_instr: "_Valuta il contributo di una capacità ai tuoi obiettivi._",
  ass_label: "La causa del problema è ben nota",
  ass_overall: "Necessità di miglioramento",
  ass_scale: "Scala per il punteggio di valutazione",
  ass_setting: "Matrice di valutazione",
  ass: "Valutazione",
  assess_content:
    "Determina per ogni capacità la sua importanza e le prestazioni attuali.",
  assess: "Valutare",
  assessment_route: "/assessment/:id",
  assessment: "Valutazione",
  avg_perf: "Valutazione complessiva",
  cap_cat: "Categoria di capacità",
  cap: "Capacità",
  caps: "Capacità",
  cat: "Categoria",
  clear_all: "Cancella tutti i filtri",
  clear: "Cancella",
  color: "Colore",
  create_cap: "Crea capacità",
  defs: "Definizioni",
  del_model: "Vuoi davvero eliminare tutto?",
  del_model_desc: "Sei sicuro di voler eliminare il tuo modello?",
  del_proj: "Elimina progetto",
  desc_cap_instr: "Descrivi la capacità in dettaglio.",
  desc: "Descrizione",
  develop_content: "Inizia a sviluppare le tue capacità.",
  develop: "Sviluppare",
  development: "Sviluppo",
  development_route: "/development/:id",
  dev_cap:
    "_Suggerisci nuovi progetti per sviluppare la tua capacità. Inizia selezionando una capacità._",
  doc_id: "ID documento",
  doc: "Documentazione",
  download: "Scarica",
  duration: "Durata",
  edit: "Modifica",
  view: "Visualizza",
  evaluation_route: "/evaluation/:id",
  evaluation: "Valutazione",
  exp_perf: "Prestazioni attese",
  expl: "Spiegazione",
  expl2: "Prestazioni",
  filter_cap: "Filtra capacità",
  filter_caps: "Filtra capacità",
  filter_ph: "Titolo o descrizione",
  filter_text_ph: "Termine o descrizione",
  filter_text: "Testo del filtro",
  filters: "Filtri",
  relevance: "Rilevanza",
  gap_scale: "Scala per la lacuna",
  gap_settings: "##### Impostazioni lacune",
  gap: "Lacuna",
  gaps_common: "Lacune comuni o cause di problemi",
  gaps: "Lacune",
  gng: "###### Decisione GO / NO GO<br>",
  go: "GO",
  goal_scale: "Scala per i temi di valutazione",
  goals_instr: "Specificare obiettivi a lungo e breve termine",
  goal: "Obiettivo",
  goals: "Obiettivi",
  group_goals_instr:
    "1. **Stabilisci gli obiettivi di gruppo che vuoi raggiungere.**\n2. Specifica i tuoi stakeholder e i loro obiettivi organizzativi.\n3. Specifica le categorie di capacità per organizzare le capacità.\n4. Specifica le capacità necessarie per raggiungere gli obiettivi di gruppo.",
  group_goals: "Specificare obiettivi di gruppo",
  home_route: "/",
  home: "HOME",
  id: "ID",
  importance: "Importanza",
  in_months: "In mesi",
  loc: "Stanza/posizione",
  main_goals: "Obiettivi",
  assess_capability_importance_for_capability:
    "Valuta l'importanza di \"{capability}\" per l'ambito scelto.",
  max_imp: "Contributo massimo",
  name: "Nome",
  no_go: "NO GO",
  no: "No",
  org_dept: "Organizzazione / Dipartimento",
  overview_route: "/overview",
  overview: "Panoramica",
  level: "Livello",
  perf_asp: "Aspetto prestazionale",
  perf_asps: "Aspetti prestazionali",
  assess_performance_aspects_for_capability:
    "Valuta gli aspetti prestazionali di {capability}.",
  perf_effectiveness_tooltip: "Quanto è efficace {capability}?",
  perf_safety_professionals_tooltip:
    "Qual è il livello di sicurezza fisica e mentale del personale operativo che lavora su {capability}?",
  perf_efficiency_tooltip: "Quanto è efficiente {capability}?",
  perf_scale: "Scala per il punteggio di prestazione",
  perf_settings: "##### Impostazioni di valutazione",
  perf: "Prestazioni",
  period: "AAAA T1 o AAAA M1",
  permalink: "Collegamento permanente",
  pers_inv: "Persone coinvolte",
  pick_more: "Scegli uno o più",
  pick_one: "Scegli uno",
  prep_content: "_Definisci gli obiettivi della tua organizzazione._",
  preparation_route: "/obiettivi",
  preparation: "Obiettivi",
  prepare_content: "Crea o seleziona le capacità importanti.",
  prepare: "Preparare",
  prob_areas: "Aree problematiche",
  gap_problem_categories_intro:
    "Analizza questo divario di capacità nelle seguenti categorie di problema.",
  gap_likert_severity: "Gravità",
  gap_likert_severity_start_label: "Molto bassa",
  gap_likert_severity_middle_label: "Media",
  gap_likert_severity_end_label: "Molto alta",
  gap_likert_probability: "Probabilità",
  gap_likert_probability_start_label: "Nessun cambiamento",
  gap_likert_probability_middle_label: "—",
  gap_likert_probability_end_label: "Grande diminuzione",
  gap_likert_impact: "Impatto",
  gap_likert_impact_start_label: "Nessun cambiamento",
  gap_likert_impact_middle_label: "—",
  gap_likert_impact_end_label: "Grande diminuzione",
  gap_likert_severity_tooltip:
    "Come valuti la gravità di questo divario di capacità?",
  gap_likert_probability_tooltip:
    "Supponendo che il divario sia risolto: cosa significherebbe per la probabilità di occorrenza del divario?",
  gap_likert_impact_tooltip:
    "Supponendo che il divario sia risolto. Cosa significherebbe per la riduzione dell'impatto del divario originale?",
  prob: "Problema",
  proj_app: "###### PROGETTO APPROVATO<br>",
  proj_name: "Nome del progetto",
  proj_prop: "Nuovo progetto o proposta",
  proj_sum: "Riepilogo del progetto",
  prop_name: "Nome della proposta",
  prop_new: "Nuova proposta",
  ref: "Riferimento",
  ref_url: "URL di riferimento",
  select_cap: "Seleziona capacità",
  select_cat: "Seleziona categoria",
  select_m_ph: "Seleziona uno o più",
  select_subcat: "Seleziona sottocategoria",
  settings_route: "/settings",
  settings: "Impostazioni",
  sh_filter: "Filtra organizzazioni coinvolte",
  sh_org: "Organizzazioni stakeholder",
  sh_settings: "##### Impostazioni stakeholder",
  sh_type: "Tipo di stakeholder",
  sh_types: "Tipi di stakeholder",
  sh: "Parte interessata",
  shs: "Parti interessate",
  other_stakeholder: "Si prega di descrivere l'altra parte interessata",
  spec_cap_instr:
    "1. Stabilisci gli obiettivi di gruppo che vuoi raggiungere.\n2. Specifica i tuoi stakeholder e i loro obiettivi organizzativi.\n3. Specifica le categorie di capacità per organizzare le capacità.\n4. **Specifica le capacità necessarie per raggiungere gli obiettivi di gruppo.**",
  spec_cap: "Specificare capacità",
  spec_cat_instr:
    "1. Stabilisci gli obiettivi di gruppo che vuoi raggiungere.\n2. Specifica i tuoi stakeholder e i loro obiettivi organizzativi.\n3. **Specifica le categorie di capacità per organizzare le capacità.**\n4. Specifica le capacità necessarie per raggiungere gli obiettivi di gruppo.",
  spec_cat: "Specificare categorie",
  spec_sh_instr:
    "1. Stabilisci gli obiettivi di gruppo che vuoi raggiungere.\n2. **Specifica i tuoi stakeholder e i loro obiettivi organizzativi.**\n3. Specifica le categorie di capacità per organizzare le capacità.\n4. Specifica le capacità necessarie per raggiungere gli obiettivi di gruppo.",
  spec_sh: "Specificare parti interessate",
  start_time: "Ora di inizio",
  subcat: "Sottocategoria",
  task_settings: "##### Impostazioni attività",
  task: "Compito",
  task2perf: "##### Tabella di corrispondenza compito-prestazione",
  tasks: "Compiti",
  ass_task_scale: "Scala dei compiti",
  ass_perf_scale: "Prestazioni",
  taxonomy_route: "/taxonomy",
  taxonomy: "Tassonomia",
  tax_def:
    "#### Tassonomia\n\nDefinizioni e abbreviazioni di termini comunemente usati.",
  TAXONOMY: {
    HAZARD: "Rischio",
    HAZARD_DEF:
      "Un processo, fenomeno o attività umana che può causare perdite di vite umane, lesioni, interruzioni o danni ambientali.",
    HAZARD_TYPE: "Tipo di rischio",
    HAZARD_TYPE_DEF:
      "Una classe di rischi con origine o caratteristiche simili, come rischi naturali, tecnologici o di origine umana.",
    DISASTER: "Catastrofe",
    DISASTER_DEF:
      "Una grave perturbazione di una comunità o società che supera la sua capacità di far fronte con le proprie risorse.",
    EMERGENCY: "Emergenza",
    EMERGENCY_DEF:
      "Una situazione che richiede un'azione coordinata immediata per proteggere la vita, la salute, i beni o l'ambiente.",
    DISASTER_RISK: "Rischio di catastrofe",
    DISASTER_RISK_DEF:
      "Il potenziale di perdite da eventi pericolosi, determinato dall'hazard, dall'esposizione, dalla vulnerabilità e dalla capacità.",
    EXPOSURE: "Esposizione",
    EXPOSURE_DEF:
      "La presenza di persone, beni, infrastrutture e servizi in luoghi dove i rischi possono verificarsi.",
    VULNERABILITY: "Vulnerabilità",
    VULNERABILITY_DEF:
      "Condizioni che aumentano la suscettibilità di persone, beni o sistemi agli impatti dei rischi.",
    CAPACITY: "Capacità",
    CAPACITY_DEF:
      "Le forze e le risorse disponibili per anticipare, affrontare, resistere e riprendersi dagli impatti dei rischi.",
    CAPABILITY: "Capacità operativa",
    CAPABILITY_DEF:
      "Una capacità specifica e dimostrabile di un'organizzazione di svolgere compiti e ottenere risultati in condizioni definite.",
    RESILIENCE: "Resilienza",
    RESILIENCE_DEF:
      "La capacità dei sistemi e delle comunità di resistere, assorbire, adattarsi e riprendersi preservando le funzioni essenziali.",
    PREVENTION: "Prevenzione",
    PREVENTION_DEF:
      "Azioni per evitare la creazione di nuovi rischi e impedire che i rischi causino impatti dannosi.",
    MITIGATION: "Mitigazione",
    MITIGATION_DEF:
      "Misure che riducono la gravità o la probabilità degli impatti negativi di eventi pericolosi.",
    PREPAREDNESS: "Preparazione",
    PREPAREDNESS_DEF:
      "Conoscenze, piani e capacità sviluppati in anticipo per consentire un'efficace anticipazione, risposta e recupero.",
    EARLY_WARNING_SYSTEM: "Sistema di allerta precoce",
    EARLY_WARNING_SYSTEM_DEF:
      "Un sistema integrato per monitorare i rischi, valutare i rischi, comunicare avvertimenti e abilitare azioni tempestive.",
    RESPONSE: "Risposta",
    RESPONSE_DEF:
      "Azioni intraprese appena prima, durante o immediatamente dopo un evento per salvare vite e soddisfare bisogni urgenti.",
    RECOVERY: "Recupero",
    RECOVERY_DEF:
      "Il processo di ripristino e miglioramento dei mezzi di sussistenza, dei servizi, delle infrastrutture e dei sistemi dopo una catastrofe.",
    BUILD_BACK_BETTER: "Ricostruire meglio",
    BUILD_BACK_BETTER_DEF:
      "Utilizzare il recupero e la ricostruzione per ridurre i rischi futuri e migliorare la resilienza oltre le condizioni pre-catastrofe.",
    CONTINGENCY_PLANNING: "Pianificazione di emergenza",
    CONTINGENCY_PLANNING_DEF:
      "Preparazione di piani operativi specifici e accordi di coordinamento per scenari di emergenza plausibili.",
    RISK_ASSESSMENT: "Valutazione del rischio",
    RISK_ASSESSMENT_DEF:
      "Un processo strutturato per identificare i rischi, analizzare le conseguenze e stimare i rischi a supporto delle decisioni.",
    RISK_COMMUNICATION: "Comunicazione del rischio",
    RISK_COMMUNICATION_DEF:
      "Scambio bidirezionale di informazioni sui rischi tra autorità, soccorritori, parti interessate e pubblico.",
    SITUATION_AWARENESS: "Consapevolezza situazionale",
    SITUATION_AWARENESS_DEF:
      "Una comprensione attuale e condivisa delle condizioni dell'incidente, degli impatti, delle risorse e dei probabili sviluppi.",
    INCIDENT_COMMAND: "Comando di incidente",
    INCIDENT_COMMAND_DEF:
      "Una struttura di comando e coordinamento per gestire ruoli, decisioni e risorse durante gli incidenti.",
    STAKEHOLDER: "Parte interessata",
    STAKEHOLDER_DEF:
      "Qualsiasi organizzazione, gruppo o individuo con un ruolo, una responsabilità o un interesse nella preparazione, risposta o recupero.",
    INTEROPERABILITY: "Interoperabilità",
    INTEROPERABILITY_DEF:
      "La capacità di organizzazioni, team e sistemi di lavorare insieme efficacemente attraverso procedure, dati e tecnologia.",
    CAPABILITY_GAP: "Lacuna di capacità",
    CAPABILITY_GAP_DEF:
      "La differenza tra i livelli di capacità richiesti e attuali necessari per raggiungere i risultati target.",
    CAPABILITY_ASSESSMENT: "Valutazione delle capacità",
    CAPABILITY_ASSESSMENT_DEF:
      "Una valutazione strutturata dell'importanza e delle prestazioni delle capacità per identificare le priorità di miglioramento.",
    SOLUTION: "Soluzione",
    SOLUTION_DEF:
      "Una misura, pratica, tecnologia o intervento proposto per affrontare una o più lacune di capacità.",
    SOLUTION_ASSESSMENT: "Valutazione delle soluzioni",
    SOLUTION_ASSESSMENT_DEF:
      "Una valutazione sistematica delle soluzioni candidate rispetto ai bisogni degli utenti, all'idoneità operativa, all'impatto e alla conformità.",
    ROADMAP: "Piano d'azione",
    ROADMAP_DEF:
      "Un piano di implementazione graduale che mostra cosa sarà consegnato, da chi e quando.",
    IMPLEMENTATION_TIMELINE: "Cronoprogramma di implementazione",
    IMPLEMENTATION_TIMELINE_DEF:
      "La sequenza e i tempi pianificati di attività, traguardi e risultati per l'implementazione.",
    PRIORITIZATION: "Prioritizzazione",
    PRIORITIZATION_DEF:
      "Classificazione delle azioni o degli investimenti in base all'urgenza, all'impatto atteso, alla fattibilità e alle risorse disponibili.",
    MONITORING_EVALUATION: "Monitoraggio e valutazione",
    MONITORING_EVALUATION_DEF:
      "Monitoraggio continuo e revisione periodica dei progressi, dei risultati e dell'efficacia per supportare l'apprendimento e l'adeguamento.",
    LESSONS_LEARNED: "Lezioni apprese",
    LESSONS_LEARNED_DEF:
      "Informazioni documentate da operazioni ed esercitazioni utilizzate per migliorare la pianificazione e le prestazioni future.",
    SESSION: "Sessione di valutazione",
    SESSION_DEF:
      "Un contesto di lavoro salvato contenente rischi selezionati, valutazioni, soluzioni e dati del piano d'azione.",
    COMPLIANCE_CHECK: "Verifica di conformità",
    COMPLIANCE_CHECK_DEF:
      "Una verifica che le soluzioni e le azioni proposte soddisfino i requisiti legali, politici, etici e di settore.",
    TECHNOLOGY_READINESS_LEVEL: "Livello di maturità tecnologica",
    TECHNOLOGY_READINESS_LEVEL_DEF:
      "Una scala da 1 a 9 che indica la maturità di una tecnologia dal concetto al dispiegamento operativo.",
  },
  term: "Termine",
  title: "Titolo",
  upload: "Carica",
  url: "URL",
  value: "Valore",
  yes: "Sì",
  TBD: "Sconosciuto",
  general_settings: "Generale",
  enable_sol_ass_support: "Valutazione soluzioni abilitata",
  logo: "Logo utente",
  attribution_logo: "Logo di attribuzione",
  attribution_text: "Testo di attribuzione",
  order: "Ordine",
  hide: "Nascondi nella panoramica",
  select_user: "Seleziona utente",
  user: "Utente standard",
  moderator: "Moderatore",
  admin: "Amministratore",
  doc_title: "Rapporto di valutazione delle capacità",
  export_to_word: "Esporta in Word",
  export_all_to_word: "Esporta il report completo in Word",
  add_gap: "Aggiungi lacuna di capacità",
  ignore: "Non applicabile",
  continue: "Continua",
  hazards: "Rischi",
  hazards_route: "/hazards",
  hazard_step_title: "Passo 0: Avvio e Preparazione",
  hazard_step_desc:
    "Seleziona i tipi di rischio rilevanti per l'ambito che si desidera affrontare in questo workshop di valutazione.",
  workshop_scope: "Ambito del workshop",
  hazard_category_all: "Tutti",
  hazard_category_natural: "Naturale",
  hazard_category_technical: "Tecnico",
  hazard_category_attack: "Attacco",
  hazard_edit: "Modifica tipi di rischio",
  hazard_done: "Termina modifica",
  hazard_add: "Aggiungi nuovo tipo di rischio",
  hazard_name: "Nome del rischio",
  hazard_description: "Descrizione / contesto",
  hazard_selected_count: "{n} tipo/i di rischio selezionato/i.",
  solutions: "Soluzioni",
  solution_count: {
    1: "1 soluzione",
    n: "{n} soluzioni",
  },
  solutions_route: "/solutions",
  solutions_step_title: "Passo 2: Valutazione delle soluzioni",
  solutions_step_desc:
    "Aggiungere e valutare soluzioni per le lacune identificate.",
  solution_add: "Aggiungi soluzione",
  solution_new: "Nuova soluzione",
  solution_gaps_found: {
    1: "1 lacuna di capacità identificata",
    n: "{n} lacune di capacità identificate",
  },
  solution_empty:
    "Nessuna soluzione aggiunta finora. Fai clic su 'Aggiungi soluzione' per iniziare.",
  roadmap: "Piano d'azione",
  roadmap_count: {
    1: "1 elemento del piano d'azione",
    n: "{n} elementi del piano d'azione",
  },
  roadmap_route: "/roadmap",
  roadmap_step_title: "Passo 3: Piano d'azione",
  roadmap_step_desc: "Pianifica i tempi di implementazione e gli impegni.",
  roadmap_add_solutions: "Aggiungi {n} soluzione/i al piano d'azione",
  roadmap_empty_solutions:
    "Completa prima il passo 2 (Valutazione delle soluzioni) per aggiungere soluzioni al piano d'azione.",
  roadmap_empty: "Nessun elemento nel piano d'azione.",
  roadmap_timeline: "Cronoprogramma",
  session_create: "Crea",
  session_new_name: "Nome della nuova sessione",
  session_sessions: "Sessioni di valutazione",
  session_name: "Nome",
  session_updated: "Ultimo aggiornamento",
  session_actions: "Azioni",
  session_clone: "Clona sessione",
  session_download: "Scarica come JSON",
  session_delete: "Elimina sessione",
  session_import: "Importa JSON",
  session_delete_confirm: "Elimina sessione: {name}?",
  session_delete_warning: "Questa azione non può essere annullata. Sei sicuro?",
  dashboard_subtitle:
    "Segui i passaggi seguenti per completare la valutazione della gestione delle catastrofi.",
  back_to_sessions: "Torna alle sessioni",
  step0_title: "Avvio e Preparazione",
  step1_title: "Valutazione dei bisogni e delle lacune",
  step2_title: "Valutazione delle soluzioni",
  step3_title: "Piano d'azione",
  summary: "Riepilogo",
  selected_hazards: "Rischi selezionati",
  capability_gaps: "Lacune di capacità",
  more: "altro",
  partially: "Parzialmente",
  not_assessed: "Non valutato",
  enabled_steps: "Passi abilitati",
  priority_low: "Bassa",
  priority_medium: "Media",
  priority_high: "Alta",
  sol_trl: "Livello di maturità tecnologica",
  trl1: "Principi di base osservati",
  trl2: "Concetto tecnologico formulato",
  trl3: "Prova di concetto sperimentale",
  trl4: "Tecnologia validata in laboratorio",
  trl5: "Tecnologia validata in ambiente rilevante",
  trl6: "Tecnologia dimostrata in ambiente rilevante",
  trl7: "Prototipo di sistema dimostrato in ambiente operativo",
  trl8: "Sistema completo e qualificato",
  trl9: "Sistema reale provato in ambiente operativo",
  sol_integration_rl: "Livello di prontezza all'integrazione",
  sol_societal_rl: "Livello di prontezza sociale",
  sol_manufacturing_rl: "Livello di prontezza alla produzione",
  sol_commercialisation_rl: "Livello di prontezza alla commercializzazione",
  sol_security_rl: "Livello di prontezza della sicurezza",
  sol_legal_privacy_ethical_rl:
    "Livello di prontezza giuridica, privacy ed etica",
  integration_rl1:
    "È stato individuato un concetto di alto livello per l'integrazione",
  integration_rl2:
    "Esiste un certo livello di specificità dei requisiti per l'interazione tra i componenti",
  integration_rl3:
    "Il progetto di integrazione dettagliato è stato definito includendo tutti i dettagli dell'interfaccia",
  integration_rl4:
    "Validazione delle funzioni dei componenti integrati in un ambiente di laboratorio",
  integration_rl5:
    "Validazione dei componenti integrati in un ambiente rilevante",
  integration_rl6:
    "Validazione dei componenti integrati in un ambiente end-to-end rilevante",
  integration_rl7:
    "Dimostrazione dell'integrazione del prototipo in un ambiente operativo ad alta fedeltà",
  integration_rl8: "Test e dimostrazione in un ambiente operativo",
  integration_rl9:
    "Integrazione di sistema comprovata attraverso capacità operative di missione di successo",
  societal_rl1:
    "Identificazione del bisogno sociale generico, del bene sociale e degli aspetti associati",
  societal_rl2:
    "Formulazione del concetto di soluzione proposto e dei potenziali impatti",
  societal_rl3:
    "Un gruppo limitato della società conosce la soluzione o iniziative simili",
  societal_rl4:
    "Un gruppo limitato della società testa la soluzione o iniziative simili",
  societal_rl5:
    "La società conosce la soluzione o iniziative simili ma non è consapevole dei loro benefici",
  societal_rl6:
    "La società conosce la soluzione e aumenta la consapevolezza dei suoi benefici",
  societal_rl7:
    "La società è pienamente consapevole dei benefici della soluzione",
  societal_rl8:
    "La società è pronta ad adottare la soluzione e ha utilizzato soluzioni simili sul mercato",
  societal_rl9:
    "La società sta utilizzando la soluzione ed essa è supportata dagli stakeholder e dal pubblico",
  manufacturing_rl1: "Implicazioni di produzione di base identificate",
  manufacturing_rl2: "Concetti di produzione identificati",
  manufacturing_rl3: "Sviluppata la prova di concetto della produzione",
  manufacturing_rl4:
    "Capacità di produrre la tecnologia in un ambiente di laboratorio",
  manufacturing_rl5:
    "Capacità di produrre i componenti prototipali in un ambiente rilevante per la produzione",
  manufacturing_rl6:
    "Capacità di produrre un prototipo di sistema o sottosistema in un ambiente rilevante per la produzione",
  manufacturing_rl7:
    "Capacità di produrre sistemi, sottosistemi o componenti in un ambiente rappresentativo della produzione",
  manufacturing_rl8:
    "Capacità della linea pilota dimostrata. Pronto per avviare una produzione a basso ritmo",
  manufacturing_rl9:
    "Produzione a basso ritmo dimostrata. Capacità disponibile per avviare la produzione a pieno ritmo",
  commercialisation_rl1: "Ricerca e ipotesi di base",
  commercialisation_rl2: "Valutazione del mercato",
  commercialisation_rl3:
    "Validazione dell'applicazione tecnologica e del mercato",
  commercialisation_rl4: "Proposta di valore",
  commercialisation_rl5: "Sviluppo del prodotto e allineamento al mercato",
  commercialisation_rl6:
    "Ottimizzazione del prodotto/della soluzione e protezione della proprietà intellettuale",
  commercialisation_rl7: "Validazione tecnica e commerciale",
  commercialisation_rl8:
    "Strategia di commercializzazione e introduzione sul mercato",
  commercialisation_rl9: "Lancio completo e ricavi da licenze",
  security_rl1: "Considerazione della sicurezza",
  security_rl2: "Sviluppo del concetto di sicurezza",
  security_rl3: "Sicurezza by design",
  security_rl4: "Preparazione di misure e funzionalità di sicurezza",
  security_rl5: "Semplice validazione della sicurezza",
  security_rl6: "Dimostrazione sequenziale della sicurezza",
  security_rl7: "Dimostrazioni complesse della sicurezza",
  security_rl8:
    "Validazione finale della sicurezza pre-rilascio e preparazione",
  security_rl9: "Sicurezza operativa iniziale",
  security_rl10: "Sicurezza ben consolidata/affidabile",
  legal_privacy_ethical_rl1:
    "Controllo delle questioni legali, etiche e di privacy: il sistema ha implementato meccanismi di controllo per la responsabilità e ha superato benchmark standard e ottenuto certificazioni, se applicabile",
  legal_privacy_ethical_rl2:
    "Tensioni etiche affrontate tramite ethics-by-design: le considerazioni legali, etiche e di privacy del sistema sono state progettate per essere reciprocamente compatibili. Le tensioni etiche sono state affrontate in modo che il miglioramento di un aspetto non influisca negativamente su un altro",
  legal_privacy_ethical_rl3:
    "Interazioni legali, etiche e di privacy caratterizzate: sono state caratterizzate le interazioni tra le diverse considerazioni etiche e di privacy",
  legal_privacy_ethical_rl4:
    "Questioni legali, etiche e di privacy identificate: le considerazioni etiche e di privacy sollevate dal sistema sono state identificate e anticipate",
  sol_linked_caps: "Capacità collegate (con lacune)",
  sol_addressed_gaps: "Lacune di capacità affrontate",
  sol_no_gaps:
    "Non sono ancora state identificate lacune di capacità. Vai al Passo 1 per valutare le capacità.",
  sol_compliance_title: "Verifiche di conformità",
  sol_status: "Stato",
  sol_pass: "Conforme",
  sol_partial: "Parziale",
  sol_fail: "Non conforme",
  sol_na: "N/A",
  sol_not_applicable: "Non applicabile",
  sol_user_needs_title: "Valutazione dei bisogni degli utenti",
  sol_operational_needs_title: "Valutazione dei bisogni operativi",
  sol_organisational_needs_title: "Valutazione dei bisogni organizzativi",
  sol_expected_impact_title: "Valutazione dell'impatto atteso",
  sol_question: "Domanda",
  sol_response: "Risposta",
  UN01: "La soluzione è facile da usare?",
  UN02: "È probabile che la soluzione funzioni adeguatamente sotto pressione? Inclusa robustezza e affidabilità.",
  UN03: "È probabile che la soluzione venga accettata dagli utenti?",
  UN04: "È probabile che la soluzione supporti la comprensione degli utenti?",
  UN05: "È probabile che la soluzione supporti la spiegabilità per gli utenti?",
  UN06: "È probabile che la soluzione migliori l'efficienza degli utenti?",
  UN07: "È probabile che la soluzione migliori l'efficacia degli utenti?",
  UN08: "È probabile che la soluzione fornisca conoscenza aggiuntiva?",
  UN09: "È probabile che la soluzione produca costantemente interventi e/o risultati positivi?",
  ON01: "È probabile che la soluzione richieda un'estesa (ri-)formazione?",
  ON02: "È probabile che la soluzione richieda manutenzione e supporto eccessivi?",
  ON03: "È probabile che la soluzione sia compatibile con i metodi operativi/POS?",
  ON04: "La soluzione è interoperabile?",
  ON05: "È probabile che la soluzione sia adattabile e trasferibile nei tuoi scenari operativi?",
  ON06: "È probabile che la soluzione supporti la salute e la sicurezza dei soccorritori?",
  ON07: "È probabile che la soluzione raggiunga la popolazione target prevista?",
  ON08: "È probabile che la soluzione offra maggiore efficienza operativa?",
  ON09: "È probabile che la soluzione offra maggiore efficacia operativa?",
  OG01: "È probabile che la soluzione abbia un bilancio costi-benefici positivo?",
  OG02: "La soluzione sembra fattibile? Incluso tecnologicamente, economicamente, legalmente, operativamente e temporalmente.",
  OG03: "È probabile che la soluzione sia compatibile con la cultura organizzativa?",
  OG04: "È probabile che la soluzione sia compatibile con il mandato organizzativo?",
  OG05: "È probabile che la soluzione sia compatibile con le priorità della governance della gestione delle crisi?",
  OG06: "L'utilizzo della soluzione supporterebbe la reputazione presso il pubblico?",
  OG07: "L'utilizzo della soluzione aiuterebbe a migliorare le relazioni con la comunità?",
  EI01: "La soluzione sarà applicata nel contesto dell'assistenza sanitaria umana?",
  EI02: "La soluzione comporta il trattamento di dati personali?",
  EI03: "È probabile che la soluzione abbia un impatto negativo sui diritti e le libertà di individui e gruppi? Es. privacy, dignità, autonomia, solidarietà.",
  EI04: "È probabile che la soluzione abbia un impatto negativo in termini di giustizia sociale e uguaglianza?",
  EI05: "È probabile che la soluzione abbia un impatto negativo sul benessere di individui o gruppi?",
  EI06: "È probabile che la soluzione aumenti la vulnerabilità di individui o gruppi?",
  EI07: "È probabile che la soluzione ponga potenziali rischi per la sicurezza?",
  EI08: "È probabile che la soluzione abbia un impatto negativo sull'ambiente?",
  EI09: "Esiste un'incertezza SIGNIFICATIVA riguardo agli impatti legali, etici e sociali dell'uso della soluzione?",
  CC01: "Sicurezza (informatica)",
  CC02: "Interoperabilità",
  CC03: "Regolamento sull'IA",
  CC04: "Coinvolgimento della comunità",
  CC05: "GDPR",
  CC06: "Diritti fondamentali",
  CC07: "Obiettivi di sviluppo sostenibile",
  CC08: "Priorità nazionali di gestione delle crisi",
  CC09: "Standard specifici del settore",
  CC10: "Leggi e normative specifiche del settore",
  cap_add_from_ref: "Aggiungi capacità dal riferimento",
  cap_all_selected:
    "Tutte le capacità di riferimento sono state aggiunte alla tua sessione.",
  cap_add_selected: "Aggiungi capacità selezionate",
  cap_ref_panel_title: "Capacità disponibili (modello di riferimento DASF)",
  collapse: "Comprimi",
  step0_abbr: "Passo 0: A&P",
  step0_desc:
    "Identificare i tipi di rischio rilevanti per il contesto di valutazione.",
  step1_abbr: "Passo 1: VBL",
  step1_desc:
    "Valutare le capacità, identificare lacune e necessità di miglioramento.",
  step2_abbr: "Passo 2: VS",
  step2_desc: "Valutare le soluzioni per le lacune di capacità identificate.",
  step3_abbr: "Passo 3: PA",
  step3_desc:
    "Pianificare la tabella di marcia dell'implementazione e gli impegni.",
  landing_attribution:
    "DIREKTION ha ricevuto finanziamenti dal programma di ricerca e innovazione Orizzonte Europa dell'Unione Europea nell'ambito dell'accordo di sovvenzione n. 101121249.",
  landing_developed_by: "Sviluppato da",
  landing_as_part_of: "nell'ambito del",
  landing_project: "progetto.",
  dasf_purpose_title: "Scopo del DASF",
  dasf_purpose_p1:
    "Il DIREKTION Assessment and Screening Framework (DASF) è un metodo fondamentale sviluppato nell'ambito del progetto DIREKTION per supportare un processo di selezione e valutazione trasparente e imparziale.",
  dasf_purpose_offers:
    "Il framework DASF offre un metodo passo dopo passo per:",
  dasf_purpose_item1: "Identificare e affrontare le lacune nelle capacità",
  dasf_purpose_item2:
    "Implementare una selezione sistematica di tecnologie e soluzioni",
  dasf_purpose_item3: "Definire una roadmap",
  dasf_purpose_p2:
    "Il DASF fornisce la base per un processo sostenibile di programmazione della ricerca, garantendo che i soccorritori e le parti interessate abbiano accesso agli strumenti più efficaci e aggiornati per la preparazione e la risposta ai disastri. L'insieme completo è concepito per essere eseguito regolarmente — ad esempio, una volta all'anno o una volta ogni quattro anni — per ottenere una visione aggiornata delle esigenze di capacità più attuali, delle lacune nelle capacità, delle soluzioni potenziali e per aggiornare regolarmente la roadmap per le opportunità di ricerca dell'UE o nazionali.",
  landing_assessment_process: "Processo di valutazione",
  landing_video_tutorial: "Guarda il video tutorial su YouTube",
  landing_funded_by: "Finanziato dall'Unione europea",
  landing_trilateral_attribution:
    "Per la creazione di questo strumento sono stati utilizzati contributi essenziali di Trilateral Research, sviluppati nell'ambito di DIREKTION D1.2.",
  delete_session_confirm: "Elimina sessione: {name}?",
  delete_session_warning: "Questa azione non può essere annullata. Sei sicuro?",
  N01: "Terremoto",
  N02: "Tsunami",
  N03: "Eruzione vulcanica",
  N04: "Frana / Valanga",
  N05: "Alluvione",
  N06: "Piena improvvisa",
  N07: "Tempesta / Uragano / Tornado",
  N08: "Incendio boschivo",
  N09: "Temperatura estrema (caldo/freddo)",
  N10: "Siccità",
  N11: "Epidemia / Pandemia",
  N12: "Focolaio di malattia animale",
  N13: "Infestazione di insetti",
  T01: "Incidente industriale (CBRN)",
  T02: "Incidente nucleare / Radiologico",
  T03: "Incidente di trasporto (aereo)",
  T04: "Incidente di trasporto (ferroviario)",
  T05: "Incidente di trasporto (stradale)",
  T06: "Incidente di trasporto (marittimo)",
  T07: "Gasdotto / Esplosione di gas",
  T08: "Crollo di edificio / struttura",
  T09: "Cedimento di diga / argine",
  T10: "Blackout / Guasto della rete elettrica",
  T11: "Guasto delle telecomunicazioni",
  T12: "Contaminazione della fornitura idrica",
  T13: "Sversamento di materiali pericolosi",
  A01: "Attacco terroristico (esplosivo)",
  A02: "Attacco terroristico (CBRN)",
  A03: "Attacco informatico",
  A04: "Sparatoria / Aggressione armata",
  A05: "Sabotaggio di infrastrutture critiche",
  A06: "Presa di ostaggi / Sequestro",
  A07: "Disordini civili / Sommosse",
  A08: "Pirateria marittima / Dirottamento",
  A09: "Attacco con droni",
  A10: "Minaccia ibrida",
  A11: "Campagna di disinformazione",
  A12: "Interruzione della catena di approvvigionamento (intenzionale)",
  A13: "Incendio doloso",
  "Cat-01": "Mitigazione / Prevenzione",
  "Cat-02": "Preparazione",
  "Cat-03": "Risposta",
  "Cat-04": "Recupero",
  "Mit-01": "Valutazione del rischio",
  "Mit-02": "Riduzione dell'esposizione",
  "Mit-03": "Supporto alla mitigazione",
  "Prep-01": "Sviluppo delle capacità",
  "Prep-02": "Monitoraggio",
  "Prep-03": "Supporto alla preparazione",
  "Rsp-01": "Soppressione dell'incidente",
  "Rsp-02": "Operazioni di soccorso",
  "Rsp-03": "Sicurezza / Applicazione della legge",
  "Rsp-04": "Assistenza sanitaria di emergenza",
  "Rsp-05": "Comunicazione verso la società",
  "Rsp-06": "Protezione della popolazione / animali",
  "Rsp-07": "Sgombero dell'area colpita",
  "Rsp-08": "Fornitura di bisogni primari",
  "Rsp-09": "Supporto alla risposta",
  "Rec-01": "Recupero umanitario",
  "Rec-02": "Recupero ambientale",
  "Rec-03": "Recupero economico",
  "Rec-04": "Ripristino delle infrastrutture",
  "Rec-05": "Supporto al recupero",
  "Mit-RA-01": "Identificazione dei rischi",
  "Mit-RA-02": "Analisi dei rischi",
  "Mit-RA-03": "Valutazione dei rischi",
  "Mit-ER-01": "Protezione dei beni",
  "Mit-ER-02": "Protezione delle risorse naturali",
  "Mit-ER-03": "Sensibilizzazione",
  "Mit-MS-01": "Analisi delle tendenze",
  "Mit-MS-02": "Monitoraggio e revisione",
  "Prep-CD-01": "Pianificazione della risposta e del recupero",
  "Prep-CD-02": "Formazione",
  "Prep-CD-03": "Comunicazione del rischio",
  "Prep-MO-01": "Rilevamento",
  "Prep-MO-02": "Allerta",
  "Prep-PS-01": "Gestione del personale",
  "Prep-PS-02": "Gestione degli asset",
  "Prep-PS-03": "Stabilimento della cooperazione",
  "Prep-EH-04": "Assistenza psicologica",
  "Resp-SI-01": "Lotta agli incendi - Infrastrutture",
  "Resp-SI-02": "Lotta agli incendi - Natura",
  "Resp-SI-03": "Controllo delle alluvioni",
  "Resp-SI04": "Controllo delle materie pericolose (CBRN-E)",
  "Resp-RO-01": "Ricerca e Soccorso (SAR)",
  "Resp-RO-02": "Trattamento delle vittime in loco",
  "Resp-RO-03": "Trasporto delle vittime",
  "Resp-SL-01": "Messa in sicurezza di luoghi / persone",
  "Resp-SL-02": "Identificazione delle persone",
  "Resp-SL-03": "Medicina legale",
  "Resp-SL-04": "Mantenimento dell'ordine pubblico",
  "Resp-SL-05": "Gestione del traffico",
  "Resp-EH-01": "Cure urgenti - Ospedali",
  "Resp-EH-02": "Quarantena",
  "Resp-EH-03": "Salute pubblica di massa",
  "Resp-CS-01": "Avviso",
  "Resp-CS-02": "Comunicazione di crisi",
  "Resp-SF-01": "Evacuazione",
  "Resp-SF-02": "Rifugio",
  "Resp-SF-03": "Riunificazione",
  "Resp-DA-01": "Rimozione delle macerie",
  "Resp-DA-02": "Decontaminazione degli oggetti",
  "Resp-DA-03": "Drenaggio",
  "Resp-DA-04": "Abbattimento di animali",
  "Resp-BN-01": "Fornitura di acqua potabile",
  "Resp-BN-02": "Fornitura di alimenti",
  "Resp-BN-03": "Fornitura di energia",
  "Resp-BN-04": "Fornitura di ICT / Telecomunicazioni",
  "Resp-BN-05": "Servizi igienico-sanitari",
  "Resp-RS-01": "Comando, Controllo e Coordinamento",
  "Resp-RS-02": "Valutazione della situazione",
  "Resp-RS-03": "Gestione delle informazioni",
  "Resp-RS-04": "Monitoraggio / Raccolta dati",
  "Resp-RS-05": "Supporto alle operazioni in loco",
  "Resp-RS-06": "Logistica",
  "Rec-HR-01": "Salute pubblica e sicurezza",
  "Rec-HR-02": "Cibo e rifugio",
  "Rec-ER-01": "Gestione dei rifiuti",
  "Rec-ER-02": "Ripristino degli habitat",
  "Rec-EC-01": "Recupero delle imprese",
  "Rec-EC-02": "Recupero finanziario",
  "Rec-RI-01": "Ripristino dei trasporti",
  "Rec-RI-02": "Ripristino dei servizi pubblici",
  "Rec-RS-01": "Stabilimento dell'organizzazione di recupero",
  "Rec-RS-02": "Programmazione del recupero",
  "Goal-01": "Prevenire gli incidenti",
  "Goal-01_desc": "Prevenire catastrofi / situazioni di crisi.",
  "Goal-02": "Minimizzare le perdite da rischi",
  "Goal-02_desc": "Ridurre / evitare le perdite da rischi.",
  "Goal-03": "Aiutare le vittime",
  "Goal-03_desc": "Assicurare assistenza rapida ed efficace alle vittime.",
  "Goal-04": "Recupero adeguato",
  "Goal-04_desc": "Ottenere un recupero rapido ed efficace.",
  "TO-01": "Vigili del fuoco / Protezione civile",
  "TO-02": "Polizia",
  "TO-03": "Assistenza sanitaria di emergenza",
  "TO-04": "Difesa",
  "TO-05": "Centro di comando",
  "TO-06": "Autorità",
  "TO-07": "Infrastrutture critiche",
  "TO-08": "ONG",
  "TO-09": "Altro",
  "SH-01": "Vigili del fuoco/Protezione civile",
  "SH-02": "Polizia",
  "SH-03": "Assistenza sanitaria di emergenza",
  "SH-04": "SAR",
  "SH-05": "Centro di comando o di dispacciamento (112)",
  "SH-06": "Autorità (ministeri, comuni)",
  "SH-07": "Difesa",
  "SH-08": "Servizi pubblici",
  "SH-09": "Guardia costiera o Sicurezza delle frontiere",
  "SH-10": "Operatore di infrastrutture critiche",
  "SH-11": "ONG",
  "SH-12": "Altro (da descrivere)",
  "Imp-1": "Nessuna/Molto bassa",
  "Imp-2": "Bassa",
  "Imp-3": "Media",
  "Imp-4": "Abbastanza alta",
  "Imp-5": "Molto alta",
  "PA-1": "Efficacia",
  "PA-1_desc": "Qualità dei risultati, tempestività, resistenza.",
  "PA-2": "Sicurezza dei professionisti",
  "PA-2_desc": "Sicurezza fisica e mentale del personale coinvolto.",
  "PA-3": "Efficienza",
  "PA-3_desc": "Rapporto tra costi e risultati.",
  "PSc-1": "Scarso",
  "PSc-2": "Insoddisfacente",
  "PSc-3": "Moderato",
  "PSc-4": "Soddisfacente",
  "PSc-5": "Buono",
  "Nat-01": "Tecnologico",
  "Nat-01_desc":
    "Es. Tecnologie di rilevamento, comando e controllo, comunicazioni e coordinamento, ICT.",
  "Nat-02": "Umano",
  "Nat-02_desc":
    "Es. Quantità di personale, competenza del personale, formazione e istruzione.",
  "Nat-03": "Organizzativo",
  "Nat-03_desc":
    "Es. Procedure, struttura organizzativa, aspetti finanziari, accordi.",
  "Nat-04": "Regolatorio",
  "Nat-04_desc": "Es. Aspetti legali, aspetti formali di standardizzazione.",
  "Kn-01": "Sconosciuto",
  "Kn-02": "No",
  "Kn-03": "Sì",
  "ASc-01": "Molto bassa",
  "ASc-02": "Bassa",
  "ASc-03": "Moderata",
  "ASc-04": "Alta",
  "ASc-05": "Molto alta",
  "Cat-01_desc":
    "Obiettivo: Adottare misure per limitare la probabilità e ridurre l'impatto di un incidente, catastrofe o crisi.",
  "Cat-02_desc":
    "Obiettivo: Sviluppare e mantenere la struttura organizzativa e le capacità per svolgere attività di risposta e recupero.",
  "Cat-03_desc": "Obiettivo: Salvare vite e limitare gli effetti negativi.",
  "Cat-04_desc":
    "Obiettivo: Ricostruire e ripristinare la vita normale in modo efficiente.",
  "Mit-01_desc": "Identificazione, analisi e valutazione dei rischi.",
  "Mit-02_desc":
    "Protezione di beni, risorse naturali e società in generale dai rischi.",
  "Mit-03_desc": "Capacità a supporto della mitigazione / prevenzione.",
  "Prep-01_desc":
    "Processo di sviluppo e mantenimento delle capacità di gestione delle crisi richieste.",
  "Prep-02_desc":
    "Determinare lo stato di un ambiente o situazione per consentire il rilevamento degli incidenti.",
  "Prep-03_desc": "Capacità a supporto dello sviluppo delle capacità.",
  "Rsp-01_desc":
    "Attività in loco per fermare o contenere la causa della catastrofe.",
  "Rsp-02_desc": "Attività in loco per salvare vite.",
  "Rsp-03_desc":
    "Messa in sicurezza di aree/persone, identificazione delle persone, medicina legale.",
  "Rsp-04_desc": "Attività esterne per salvare vite.",
  "Rsp-05_desc": "Avviso e comunicazione di crisi.",
  "Rsp-06_desc": "Evacuazione controllata di persone e/o animali.",
  "Rsp-07_desc": "Garantire accessibilità e sicurezza nell'area colpita.",
  "Rsp-08_desc":
    "Fornitura e/o ripristino di prodotti di base e servizi di vitale importanza.",
  "Rsp-09_desc": "Capacità per abilitare una o più altre capacità di risposta.",
  "Rec-01_desc":
    "Fornitura di servizi di salute pubblica, sicurezza e rifugio.",
  "Rec-02_desc": "Rimozione dell'inquinamento e decontaminazione.",
  "Rec-03_desc": "Recupero economico e aziendale.",
  "Rec-04_desc": "Ripristino di percorsi di trasporto e servizi essenziali.",
  "Rec-05_desc": "Capacità necessarie per un recupero ben coordinato.",
  "Mit-RA-01_desc":
    "Processo di ricerca, riconoscimento e descrizione del rischio.",
  "Mit-RA-02_desc":
    "Processo per comprendere la natura del rischio e determinare il livello di rischio.",
  "Mit-RA-03_desc":
    "Processo di confronto dei risultati dell'analisi dei rischi con i criteri di rischio per determinare se il rischio è accettabile o tollerabile.",
  "Mit-ER-01_desc": "Protezione dei beni (incluse le infrastrutture critiche).",
  "Mit-ER-02_desc":
    "Azioni che minimizzano le perdite da rischi e preservano o ripristinano le funzioni dei sistemi naturali.",
  "Mit-ER-03_desc":
    "Educazione pubblica e sensibilizzazione sui rischi e sui potenziali modi per mitigarli.",
  "Mit-MS-01_desc": "Indagine sull'evoluzione dei rischi.",
  "Mit-MS-02_desc":
    "Garantire che i controlli siano efficaci ed efficienti, ottenendo ulteriori informazioni per migliorare la valutazione dei rischi.",
  "Prep-CD-01_desc":
    "Sviluppare, compilare e mantenere procedure e informazioni pronte per l'uso in un incidente.",
  "Prep-CD-02_desc":
    "Attività per facilitare l'apprendimento e lo sviluppo di conoscenze, abilità e competenze per la risposta ai disastri.",
  "Prep-CD-03_desc":
    "Comunicare e istruire il pubblico su come essere ben preparati a una crisi e come comportarsi quando si verifica.",
  "Prep-MO-01_desc":
    "Rilevamento di circostanze che si discostano dalla norma.",
  "Prep-MO-02_desc":
    "Allertare il personale della presenza di un incidente e consentire l'avvio di azioni di controllo.",
  "Prep-PS-01_desc":
    "Attività per fornire personale sufficiente e qualificato per svolgere compiti di risposta e recupero.",
  "Prep-PS-02_desc":
    "Attività per fornire attrezzature, strumenti, ICT e altri asset necessari per risposta e recupero.",
  "Prep-PS-03_desc":
    "Stabilimento della cooperazione internazionale tra servizi di emergenza e terzi.",
  "Prep-EH-04_desc":
    "Assistenza sanitaria psicologica per vittime, familiari e altre persone colpite dall'incidente.",
  "Resp-SI-01_desc":
    "Lotta agli incendi in edifici, aree urbanizzate o infrastrutture.",
  "Resp-SI-02_desc": "Lotta agli incendi in ambienti naturali.",
  "Resp-SI-03_desc":
    "Gestione delle acque in caso di alluvione dovuta a rottura di argine o forti piogge.",
  "Resp-SI04_desc":
    "Fermare il rilascio di materiali pericolosi, incluso il contenimento (incidenti CBRN-E).",
  "Resp-RO-01_desc": "Operazioni di ricerca e soccorso.",
  "Resp-RO-02_desc":
    "Triage, decontaminazione e stabilizzazione delle vittime.",
  "Resp-RO-03_desc": "Trasporto in ambulanza verso aree sicure o ospedali.",
  "Resp-SL-01_desc":
    "Proteggere aree, infrastrutture e persone da parti non coinvolte.",
  "Resp-SL-02_desc": "Identificazione delle vittime.",
  "Resp-SL-03_desc":
    "Attività di medicina legale per indagare sulla causa dell'incidente e salvaguardare le prove.",
  "Resp-SL-04_desc": "Controllo delle sommosse, ecc.",
  "Resp-SL-05_desc":
    "Controllo del traffico in entrata e in uscita dall'area colpita.",
  "Resp-EH-01_desc": "Servizio sanitario in ospedali regolari e/o da campo.",
  "Resp-EH-02_desc": "Isolamento di persone/vittime potenzialmente infettive.",
  "Resp-EH-03_desc":
    "Profilassi di massa o vaccinazione in caso di incidente nucleare o pandemia.",
  "Resp-CS-01_desc":
    "Avvisare la società nella zona minacciata fornendo informazioni tempestive e adeguate sulla minaccia.",
  "Resp-CS-02_desc":
    "Fornire informazioni sulla catastrofe alla società, inclusa la gestione dei volontari e gli appelli.",
  "Resp-SF-01_desc":
    "Evacuazione controllata di persone e animali da un'area o edificio.",
  "Resp-SF-02_desc":
    "Fornitura di rifugio agli evacuati, inclusi nutrizione e servizi igienico-sanitari.",
  "Resp-SF-03_desc": "Riunificazione degli evacuati con i loro familiari.",
  "Resp-DA-01_desc": "Rimozione di macerie e/o materiale contaminato.",
  "Resp-DA-02_desc":
    "Decontaminazione di aree, infrastrutture e/o veicoli contaminati.",
  "Resp-DA-03_desc": "Drenaggio e pompaggio di aree o infrastrutture allagate.",
  "Resp-DA-04_desc": "Abbattimento di animali potenzialmente infetti.",
  "Resp-BN-01_desc": "Ripristino o fornitura temporanea di acqua potabile.",
  "Resp-BN-02_desc": "Fornitura temporanea di cibo.",
  "Resp-BN-03_desc":
    "Ripristino della fornitura di elettricità/gas o fornitura di energia alternativa temporanea.",
  "Resp-BN-04_desc":
    "Ripristino o fornitura temporanea di ICT e telecomunicazioni.",
  "Resp-BN-05_desc":
    "Ripristinare i servizi igienico-sanitari o fornire soluzioni temporanee.",
  "Resp-RS-01_desc":
    "Processo decisionale, pianificazione e assegnazione compiti ai livelli di coordinamento e comando durante un evento disastroso.",
  "Resp-RS-02_desc":
    "Sviluppo di informazioni operative attraverso l'arricchimento dei dati raccolti, incluso il quadro operativo comune.",
  "Resp-RS-03_desc":
    "Archiviazione e condivisione di informazioni come dati raccolti, valutazioni e decisioni prese.",
  "Resp-RS-04_desc":
    "Raccolta di dati tramite monitoraggio fisico (sorveglianza) e data mining.",
  "Resp-RS-05_desc":
    "Fornitura di servizi di base ai primi soccorritori in loco per abilitare le attività di risposta.",
  "Resp-RS-06_desc":
    "Trasporto di personale e materiale a supporto delle operazioni di risposta ai disastri prolungate.",
  "Rec-HR-01_desc":
    "Fornitura di servizi di salute pubblica e sicurezza per gli sfollati.",
  "Rec-HR-02_desc": "Fornitura di cibo e rifugio per gli sfollati.",
  "Rec-ER-01_desc":
    "Rimozione dell'inquinamento su larga scala e decontaminazione, e gestione dei rifiuti.",
  "Rec-ER-02_desc": "Ripristino delle risorse naturali e degli habitat.",
  "Rec-EC-01_desc":
    "Recupero aziendale di negozi e industrie colpiti dalla catastrofe.",
  "Rec-EC-02_desc": "Recupero dall'impatto finanziario sulle autorità.",
  "Rec-RI-01_desc":
    "Ripristino delle rotte di trasporto (stradale, ferroviario, idrico, aereo, gasdotti).",
  "Rec-RI-02_desc":
    "Ripristino dei servizi pubblici interrotti e altri servizi essenziali.",
  "Rec-RS-01_desc":
    "Stabilimento della struttura organizzativa di recupero per il breve e lungo termine.",
  "Rec-RS-02_desc":
    "Determinazione e attuazione del programma di recupero basato sulla valutazione degli impatti.",
  manage_capabilities: "Seleziona capacità",
  select_capabilities_instr:
    "Seleziona le capacità che desideri valutare per le lacune.",
  drawer_hazards: "Rischi",
  drawer_gaps: "Lacune",
  drawer_solutions: "Soluzioni",
  drawer_roadmap: "Piano d'azione",
  drawer_capabilities: "Capacità",
  drawer_solution: "Soluzione",
  drawer_with_gaps: "con lacune",
  drawer_no_linked_caps: "Nessuna capacità collegata",
  drawer_add_to_roadmap: "Aggiungi al piano d'azione →",
  drawer_go_to_solutions: "Vai alle soluzioni →",
  drawer_go_to_roadmap: "Vai al piano d'azione →",
  drawer_none: "Nessuno",
  drawer_relevant_hazards: "Rischi rilevanti",
  action_priority: "Priorità d'azione",
  action_priority_instr:
    "Valuta la tua disponibilità ad agire per migliorare questa capacità (1 = bassa, 5 = urgente)",
  action_priority_label_1: "Non adesso",
  action_priority_label_3: "Forse",
  action_priority_label_5: "Urgente",
  prev_cap: "Precedente",
  next_cap: "Successivo",
  about_markdown: `#### DIREKTION Assessment & Screening Framework (DASF)

L'insieme di strumenti DASF supporta il processo sistematico di valutazione e screening per la gestione dei disastri. Fornisce un approccio strutturato in 4 fasi:

1. **Iniziazione e Preparazione (I&P)**: Identificare i tipi di pericolo rilevanti e definire l'ambito della valutazione.
2. **Valutazione delle Esigenze e Lacune (VEL)**: Valutare le capacità nel ciclo di gestione dei disastri, identificare le lacune e le esigenze di miglioramento.
3. **Valutazione della Soluzione (VS)**: Valutare le soluzioni potenziali per le lacune di capacità identificate, inclusa la conformità, le esigenze degli utenti e la valutazione dell'impatto.
4. **Roadmapping (RM)**: Pianificare i tempi di implementazione e gli impegni per le soluzioni selezionate.

##### Per Iniziare

- Creare o aprire una sessione di valutazione dalla pagina iniziale
- Navigare attraverso i 4 passaggi utilizzando le icone della barra degli strumenti
- Passare tra i ruoli Utente ed Editor utilizzando il selettore di seguito

##### Ruoli

- **Utente Regolare**: Può compilare le valutazioni e visualizzare i risultati
- **Moderatore**: Può modificare la configurazione del framework (tipi di pericolo, capacità, stakeholder)
- **Amministratore**: Può modificare le scale di valutazione e le impostazioni

##### Contesto

Questo progetto ha ricevuto finanziamenti dal programma di ricerca e innovazione Horizon 2020 dell'Unione Europea. Sviluppato da TNO come parte del progetto [DIREKTION](https://www.direktion-network.org).`,

  // ── Collaboration (EN fallback) ────────────────────────────────────────────
  COLLABORATE: {
    TITLE: "Collaborate",
    ROUTE: "/collaborate",
    PAGE: "Collaboration",
  },
  FACILITATOR: "Facilitator",
  collab_page_title: "Collaboration",
  collab_send_invite: "Send Invite",
  collab_load_patch: "Load Patch",
  collab_mode_ca: "Capability Assessment",
  collab_mode_sc: "Solution Creation",
  collab_mode_sa: "Solution Assessment",
  collab_select_modes: "Select collaboration modes",
  collab_your_name: "Your name",
  collab_your_email: "Your email",
  collab_facilitator_name: "Facilitator name",
  collab_facilitator_email: "Facilitator email",
  collab_custom_message: "Optional message",
  collab_generate_link: "Send Invite by Email",
  collab_done: "Fatto - Invia risultati",
  collab_patch_loaded: "Patch loaded",
  collab_patches_count: {
    1: "1 patch received",
    n: "{n} patches received",
  },
  collab_hash_mismatch:
    "Warning: This patch was created from a different version of the model.",
  collab_session_mismatch:
    "This patch belongs to a different session and cannot be loaded.",
  collab_duplicate_ignored: "Duplicate patch ignored (already loaded).",
  collab_aggregated_results: "Aggregated Results",
  collab_apply_results: "Apply to model",
  collab_no_patches: "No patches received yet.",
  collab_invited_by: "You have been invited by {name} ({email}) to contribute.",
  collab_paste_patch: "Paste a patch link here",
  collab_load_patch_btn: "Load",
  collab_remove_patch: "Remove",
  collab_contributor: "Contributor",
  collab_received_at: "Received at",
  collab_avg_action_priority: "Avg. action priority",
  collab_task_items: "Task importance answers",
  collab_perf_items: "Performance answers",
  collab_gap_items: "Gap answers",
  collab_all_values: "All values",
  collab_avg_value: "Average",
  collab_invite_subject: "Invitation to collaborate on capability assessment",
  collab_invite_body:
    "Dear colleague,\n\nYou are invited to contribute to a capability assessment for {facilitatorName}.\n\nPlease click the link below to open the assessment tool and fill in your responses. When you are done, click the 'Done' button to send your results back.\n\nThis link is valid for one-time use — please do not share it.\n\nKind regards,\n{facilitatorName}",
  collab_patch_subject: "Capability assessment completed",
  collab_patch_body:
    "Dear {facilitatorName},\n\nI have completed the capability assessment you sent me.\n\nPlease click the link below to load my responses into the tool.\n\nKind regards,\n{userName}",
  // ── End Collaboration ───────────────────────────────────────────────────────
};
